@import "styles/variables";

.select {
  align-self: center;
  display: block;
  position: relative;
  padding-left: 22px;
  margin-bottom: 24px;
  cursor: pointer;
  font-size: 18px;
}
.select input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
/*
  Checkbox
*/
.select--checkbox {
  font-size: var(--font-size-medium);
}
.select--checkbox ~ label {
  opacity: 0.6;
}
.select-indicator--checkbox {
  position: absolute;
  top: 2px;
  left: 0;
  height: 16px;
  width: 16px;

  background-color: var(--color-white);
  border: solid 1px var(--color-grey);
}
.select input:checked ~ .select-indicator--checkbox {
  background: var(--color-yellow);
  border-color: var(--color-yellow);
}
.select input:focus ~ .select-indicator--checkbox {
  border-color: var(--color-yellow);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}
.select input:checked:focus ~ .select-indicator--checkbox {
  border-color: var(--color-border-orange-focus);
}
.select-indicator--checkbox:after {
  content: '';
  position: absolute;
  display: none;
}
.select input:checked ~ .select-indicator--checkbox:after {
  display: block;
}
.select--checkbox.checked ~ label {
  opacity: 1;
}
.select-indicator--checkbox:after {
  left: 6px;
  top: 2px;
  width: 3px;
  height: 8px;
  border: solid var(--color-black);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
/*
  Radio button
*/
.select--radio {
  border-radius: 50%;
}
.select-indicator--radio {
  position: absolute;
  top: 2px;
  left: 0;
  height: 16px;
  width: 16px;
  border-radius: 50%;

  background-color: var(--color-white);
	border: solid 2px var(--color-grey);
}
.select-indicator--radio:after {
  content: '';
  position: absolute;
  display: none;
}
.select input:checked ~ .select-indicator--radio:after {
  display: block;
}
.select-indicator--radio:after {
  left: 4px;
  top: 4px;
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: var(--color-grey);
}

/*
  Number
*/
.select--number {
  font-size: 18px;
  padding-left: 33px;
}
.select--number span {
  font-family: var(--font-stack-default);
  font-weight: 100;
  font-size: 16px;
  color: var(--color-dark-grey);
  z-index: 5;
  position: absolute;
  left: 14px;
  top: 10px;
}
.select-indicator--number {
  position: absolute;
  top: 0;
  left: 0;
  height: 33px;
  width: 33px;

  background-color: var(--color-white);
	border: solid 1px var(--color-grey);
  border-radius: 2px;
}
.select input:checked ~ .select-indicator--number {
  background: var(--color-yellow);
}
.select input:focus ~ .select-indicator--number {
  border: 2px solid;
  border-color: var(--color-yellow);
}
.select-indicator--number:after {
  content: '';
  position: absolute;
  display: none;
}
.select input:checked ~ .select-indicator--number:after {
  display: block;
}
.select-indicator--number:after {
  left: 10px;
  top: 0px;
  width: 3px;
  height: 10px;
}
